module.exports = __webpack_public_path__ + "images/emoji/registered.bbfcf3fbc2114d342ca0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/registered.png
// module id = R520
// module chunks = 1